import {
  Hero,
  InsurancePlans,
  PremiumCalculator,
  ComparePlans,
  HowItWorks,
  WhyFintoo,
  InsurancePartner,
  InsuranceSteps,
  SmartExtras,
  Testimonials,
  FinalCta,
  Faq,
} from "../../components/Insurance/landingpage";

export default function InsuranceLandingPage() {
  return (
    <main>
      <Hero />
      <InsurancePlans />
      <PremiumCalculator />
      <ComparePlans />
      <HowItWorks />
      <WhyFintoo />
      <InsurancePartner />
      <InsuranceSteps />
      <SmartExtras />
      <Testimonials />
      <FinalCta />
      <Faq />
    </main>
  );
}
